.RBUContainer
    width: 100%
    display: flex
    flex-direction: row
    justify-content: center
    align-items: center
    padding: 10px 15px
    background: rgb($globalSettingsBackgroundTertiary)
    border-radius: $globalSettingsRounding
    box-sizing: border-box
    stroke: rgb($globalSettingsFontSecondary)
    .RBUInner
        width: 100%
        display: flex
        flex-direction: column
        box-sizing: border-box
        margin-left: 10px
        justify-content: center
        align-items: center
        .Title
            font-weight: 700
            margin-bottom: 2px
        span
            text-align: center
